"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * State of processing of changed category tree structure.
 * @author Radek Beran
 */


var ProductCategoryChangeProcess =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ProductCategoryChangeProcess, _DomainObject_1$Domai);

  /**
   * @param id unique id for given import run (transfer log id)
   * @param transferCreated date and time when data transfer was created
   * @param processedByTasks stores information about task ids that have already reacted to an event
   */
  function ProductCategoryChangeProcess(id, transferCreated, processedByTasks) {
    var _this;

    _classCallCheck(this, ProductCategoryChangeProcess);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductCategoryChangeProcess).call(this));
    _this.id = id;
    _this.transferCreated = transferCreated;
    _this.processedByTasks = processedByTasks;
    return _this;
  }

  return ProductCategoryChangeProcess;
}(DomainObject_1.DomainObject);

exports.ProductCategoryChangeProcess = ProductCategoryChangeProcess;